<template>
    <div>

           <main class="main">
            <div class="bredcumb">
                <div class="container">
                    <ul>
                        <!-- <router-link  :key="index" v-for="(breadcrumb, index) in $store.state.breadcrumb"  tag="li" :to="breadcrumb.path"><a>{{breadcrumb.name}}</a></router-link> -->
                        <li><router-link to="/index"><a href="">首頁</a></router-link></li>
                        <li>鯨選大師</li>
                    </ul>
                </div>
            </div>

            <!-- <div class="category">
                <div class="trigger">
                    <div class="container">
                        全部課程
                    </div>
                </div>
                <div class="container">
                    <div class="content">
                        <ul>
                            <li class="current"><a href="#">全部課程</a></li>
                            <li><a href="#">文學賞析</a></li>
                            <li><a href="#">哲學思維</a></li>
                            <li><a href="#">文化探究</a></li>
                            <li><a href="#">經典名著</a></li>
                            <li><a href="#">詩詞朗讀</a></li>
                            <li><a href="#">健康養生</a></li>
                            <li><a href="#">家庭親子</a></li>
                            <li><a href="#">心靈成長</a></li>
                            <li><a href="#">兩性情感</a></li>
                            <li><a href="#">藝術休閒</a></li>
                            <li><a href="#">經營管理</a></li>
                            <li><a href="#">創新創業</a></li>
                            <li><a href="#">趨勢分析</a></li>
                            <li><a href="#">投資理財</a></li>
                            <li><a href="#">自我提升</a></li>
                        </ul>
                    </div>
                </div>
            </div> -->

            <div class="bodyContent">
                <div class="container">
                    <!-- <section class="conditionSection">
                        <fieldset>
                            <legend>排序：</legend>
                            <div class="inputText">
                                <select name="" id="">
                                    <option selected="selected" value="%">依上架時間</option>
                                    <option value="01">依更新時間</option>
                                    <option value="02">依熱門排序</option>
                                </select>
                            </div>
                        </fieldset>
                    </section> -->
                    <section class="normalList">
                    <ul class="slick_list tutor tutor_style2">
                            <!-- <li>
                                <figure>
                                    <div class="graphic"><img src="images/sample/course_1.jpg"></div>
                                </figure>
                                <figcaption>
                                    <h3>寶寶怎麼養才好</h3>
                                    <b>葉寶寶</b>
                                </figcaption>
                                <a href="course.html" class="fullLink" title="寶寶怎麼養才好">詳細內容</a>
                            </li> -->

                                   
                              <li v-for="(classDatas,$index) in  sort(classData) "  @click="channelClickListener (classDatas, $index)"  >

                                    <figure>
                                        <div class="graphic"><img v-bind:src="classDatas.author.imgAvatar"></div>
                                        
                                    </figure>
                                    <figcaption>
                                        <h3>{{classDatas.author.title}}</h3>
                                         <p v-html = substring(classDatas.author.description)></p>

                                    </figcaption>
                                    <a href="" class="fullLink"></a>
                                    <!-- <a  class="fullLink" title="經理的面具：掌握管理的情境">詳細內容</a> -->
                               </li>          
                        </ul>
                    </section>
                    
                    
                </div>
            </div>


        </main>

    </div>    
</template>

<script>
export default {
    name: 'async',
    metaInfo () {
      return {
        
        title: '鯨選大師 | 一刻鯨選',
        meta: [
            // OpenGraph data (Most widely used)
            {property: 'og:title', content: '鯨選大師 | 一刻鯨選'},
            {property: 'og:site_name', content: '鯨選大師 | 一刻鯨選'},
            // The list of types is available here: http://ogp.me/#types
            {property: 'og:type', content: 'website'},
            // Should the the same as your canonical link, see below.
            {property: 'og:url', content: window.location.toString()},
            {property: 'og:image', content: this.$store.state.urlDomain+'/static/logo.jpg'},
            {property: 'og:image:width', content: '200'},
            {property: 'og:image:height', content: '500'},
            // Often the same as your meta description, but not always.
            {property: 'og:description', content: '匯集各領域專家，深耕知識，隨你所選！'},
        
        ]
      }
    },
    
  
  data() {
    return {
      classData: []
    };
  },
  created() {
    this.axios
      .get(this.$store.getters.baseURL + "channels")
      .then(response => {
            this.classData = response.data.data;
            this.classData = this.stortData(response.data.data.purchase_count);


      })
      .catch(error => console.log("log:" + error));
  },
   methods: {
        channelClickListener (item, index) {
        // alert(item.id);
        let id = item.id;
// 　　　　 this.$router.push({ path: "/course" });
        this.$store.commit('courseId', id)
        this.$router.push({ path: "/channel/"+id, params: { id } });
　　　　},
        changePage(page){
          this.$router.push({ path: "/"+page});

        },
         sort: function(arr) {
            return arr.slice().sort(function(a, b) {
            return  b.purchase_count - a.purchase_count; 
        });
        },

         substring: function(arr) {
         var index  = arr.indexOf("\n");
         arr = arr.substring(0, index);
         arr = arr.replace("●　","");
         return arr;
    }


　　},

      mounted() {
        $( "body" ).removeClass('index');
      }

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/views/AuthorList.vue